import { Insurer } from '@/codebook/insurer/_types/insurer.type';

export interface Service {
	id: number;
	name: string;
	note: string;
	code: string;
	isActive: boolean;
	description: string;
	serviceMultimedias: ServiceMultimedia[];
	kinds: number[];
	mandatory: boolean;
	dependsOn: string;
	allParticipant: boolean;
	personTypes: number[];
	countingMethod: string;
	methodValue: number;
	serviceRules: ServiceRule[];
	serviceType: number;
	sell: any;
	departures: any;
	sellChannels: number[];
	availableDaysBeforeDeparture: number;
	transport: string;
	amount: number;
	insurer: Insurer['id'];
}

export interface ServiceMultimedia {
	id: number;
	multimedia: Multimedia;
	order: number;
}

export interface Multimedia {
	id: string;
	name: string;
	url: string;
}

export interface ServiceRule {
	id: number;
	rule: string;
	entityName: string;
	entityId: number;
}

export enum ServiceCountingMethods {
	CUSTOM = 'N',
	VALUE = 'V',
	PERMILLE = 'P',
}

export enum ServiceDependsOn {
	SLOT = 'S',
	DAY = 'D',
	NIGHTS_STAY = 'N',
}

export enum Transport {
	ALL = 'A',
	BUS = 'C',
	FLY = 'F',
	OWN_TRANSPORT = 'O',
}

export const CANCELLATION_INSURANCE_SERVICE_ID = 9;
